export interface NormalizeSliderPhotosInput {
  photo?: string | null;
  photos?: string[];
}

export function normalizeSliderPhotos(
  input: NormalizeSliderPhotosInput,
): string[] {
  const unique = new Set<string>();
  const normalized: string[] = [];
  const primary = (input.photo || "").trim();

  if (primary) {
    unique.add(primary);
    normalized.push(primary);
  }

  if (Array.isArray(input.photos)) {
    input.photos.forEach((item) => {
      const photo = String(item || "").trim();
      if (!photo || unique.has(photo)) {
        return;
      }

      unique.add(photo);
      normalized.push(photo);
    });
  }

  return normalized;
}

export interface ResolveActiveSlideIndexInput {
  scrollLeft: number;
  viewportWidth: number;
  slidesCount: number;
}

export function resolveActiveSlideIndex(
  input: ResolveActiveSlideIndexInput,
): number {
  if (input.slidesCount <= 1 || input.viewportWidth <= 0) {
    return 0;
  }

  const computedIndex = Math.round(input.scrollLeft / input.viewportWidth);
  return Math.min(Math.max(0, computedIndex), input.slidesCount - 1);
}
